import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  rulesContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    fontSize: theme.size.sm,
  },
  addButton: {
    width: "64px",
    height: "28px",
    fontSize: theme.size.sm,
    marginTop: "2rem",
  },
}));

export default useStyles;
